import styled, { css } from "styled-components";
import { glow, glowBoxShadow, mobileOnly } from "../common/styles/mixins";

export const Content = styled.div.attrs({ className: "content" })`
  display: flex;
  align-items: center;
  flex-direction: column;
  h1 {
    text-transform: none;
    font-size: 2.5em;
  }
  p {
    margin-top: 0;
    margin-bottom: 1em;
  }
`;

export const Main = styled.main`
  .galleries-wrapper {
    display: flex;
    gap: 1.5em;
    flex-wrap: wrap;
    ${mobileOnly(css`
      gap: 1em;
      flex-direction: column;
    `)}
  }
  .gallery-item {
    flex: 1;
    flex-basis: 400px;
    .image-wrapper {
      position: relative;
      height: 350px;
      border: 2px solid white;
      border-radius: 6px;
      overflow: hidden;
      overflow: hidden;
      img {
        object-fit: cover;
      }
    }
    h3 {
      margin: 0.5em 0;
      text-transform: none !important;
    }
  }
`;
